import { ESdChangeReason, EWFGatewayType, EWFNodeType, IWFDecision, IWFGateway } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../../shared/pure-sd";
import { WorkflowExclusiveGatewayProperties } from "./workflow-exclusive-gateway-properties";
import { WorkflowInclusiveGatewayProperties } from "./workflow-inclusive-gateway-properties";

export interface IWorkFlowGatewayPropertiesState {
  defaultPath: IWFDecision | undefined;
  decisionArrows: IWFDecision[] | undefined;
}

export interface IWorkFlowGatewayPropertiesProps {}

class WorkFlowGatewayProperties extends PureSdComponent<
  IWorkFlowGatewayPropertiesProps & IWithSDProps & IWithContextProp,
  IWorkFlowGatewayPropertiesState
> {
  constructor(props: IWorkFlowGatewayPropertiesProps & IWithSDProps & IWithContextProp) {
    super(props);
  }

  getParallelGatewayMessage = () => {
    return (
      <div style={{ margin: "8px" }}>
        <div>All paths will be executed synchronously and process will continue when all reach to join node</div>
      </div>
    );
  };

  getInclusiveGatewayMessage = () => {
    return (
      <div style={{ margin: "8px" }}>
        <div>
          Inclusive Gateway: More than one condition may be true. All satisfied paths run in parallel. If none is true,
          you can optionally define a <em>default</em> path.
        </div>
      </div>
    );
  };
  getExclusiveGatewayMessage = () => {
    return (
      <div style={{ margin: "8px" }}>
        <div>
          Exclusive Gateway: Conditions are evaluated in order and only one path can be taken. The first condition that
          evaluates to true is selected. If none is true, a <em>default</em> path can be defined.
        </div>
      </div>
    );
  };

  render() {
    const wf = this.props.sd.selectedWf;
    const gateway = this.props.sd.findNodeRecursively(this.props.sd.selectedWfNode?.id!, EWFNodeType.Gateway, wf!) as
      | IWFGateway
      | undefined;
    if (gateway === undefined) {
      return <></>;
    }

    return (
      <div>
        {gateway.gateWayType == EWFGatewayType.Conditional && (
          <>
            {" "}
            {this.getExclusiveGatewayMessage()}
            <WorkflowExclusiveGatewayProperties></WorkflowExclusiveGatewayProperties>
          </>
        )}

        {gateway.gateWayType == EWFGatewayType.Inclusive && (
          <>
            {this.getInclusiveGatewayMessage()}
            <WorkflowInclusiveGatewayProperties></WorkflowInclusiveGatewayProperties>
          </>
        )}

        {gateway.gateWayType == EWFGatewayType.Paralel && this.getParallelGatewayMessage()}
      </div>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (changeReason === ESdChangeReason.SaveWorkflow || changeReason === ESdChangeReason.WFStepMappingChange) {
      return true;
    }
    return true;
  };
}

const workFlowGatewayProperties = withContext<IWorkFlowGatewayPropertiesProps>(
  withSD<IWorkFlowGatewayPropertiesProps>(WorkFlowGatewayProperties)
);
export { workFlowGatewayProperties as WorkFlowGatewayProperties };
